import ImgixClient from '@imgix/js-core'
const imgixClient: any = new ImgixClient({
  domain: 'disco-1180.imgix.net',
  // we're shipping this token client-side with intention to restrict it later
  secureURLToken: 'wJEvukYYaxrGffCS',
})
export default imgixClient
type ContainerParams = {
  imageContainer?: HTMLElement | null | undefined
  params?: Record<string, any>
  image: string | null | undefined
  useSrcSet?: boolean
}

const IMGIX_DEFAULTS = {
  auto: 'format,compress',
  q: 75,
}

const getContainerParams = ({
  imageContainer,
  // params: Object. Any number of imgix rendering API parameters: https://docs.imgix.com/apis/rendering.
  params,
  image,
  useSrcSet,
}: ContainerParams): {
  params?: Record<string, any> | null | undefined
} => {
  let result = {}
  const { focal_points, ...restParams } = params || {}

  if (image) {
    if (!image.includes('&Expires=') && !image.includes('.gif')) {
      if (useSrcSet) {
        result = {
          ...IMGIX_DEFAULTS,
          ...restParams,
          useSrcSet: {
            widths: [
              320, 375, 425, 512, 600, 640, 768, 960, 1024, 1100, 1280, 1440,
              1678,
            ],
          },
        }
      } else {
        const size = {
          w: restParams.w,
          h: restParams.h,
        }

        if (imageContainer && !restParams.w && !restParams.h) {
          // Only set dimensions if container has valid dimensions
          try {
            const containerWidth = imageContainer.offsetWidth
            const containerHeight = imageContainer.offsetHeight
            if (containerWidth > 0 && containerHeight > 0) {
              size.w = containerWidth * 2
              size.h = containerHeight * 2
            }
          } catch (error) {
            // Handle cases where container access fails during navigation
            console.warn(
              'imgixClient: Unable to access container dimensions during optimization',
              error,
            )
          }
        }

        result = {
          ...IMGIX_DEFAULTS,
          fit: restParams.fit || 'crop',
          ...restParams,
          ...size,
        }
      }
    }
  }

  return result
}

type ImageWithFocalPointsProps = {
  image: string | null | undefined
  params?: Record<string, any> | null | undefined
}
export const getImageWithFocalPoints = ({
  image,
  params,
}: ImageWithFocalPointsProps): string | null => {
  if (!image) return null
  let result = image
  const { focal_points, useSrcSet, ...restParams } = params || {}

  if ((focal_points || restParams) && image && !image?.includes('&Expires=')) {
    if (useSrcSet) {
      result = imgixClient.buildSrcSet(
        image,
        { ...IMGIX_DEFAULTS, ...restParams },
        useSrcSet,
      )
    } else {
      result = imgixClient.buildURL(image, {
        ...IMGIX_DEFAULTS,
        ...(focal_points
          ? {
              fit: 'crop',
              crop: 'focalpoint',
              'fp-x': focal_points?.focal_point_x,
              'fp-y': focal_points?.focal_point_y,
              'fp-z': focal_points?.focal_point_z,
            }
          : {}),
        ...restParams,
      })
    }
  }

  return result
}
export const getOptimizedUrl = (
  props: ContainerParams,
): string | null | undefined => {
  const containerParams = getContainerParams(props)
  return getImageWithFocalPoints({
    image: props.image,
    params: containerParams,
  })
}
